/**
 * app-search — types + validator for the global search state of the `_app` layout.
 *
 * Centralizes the overlays mounted at the `_app` level (currently the
 * multi-account account switcher) in the URL, so pasting the URL in another browser
 * reopens exactly the same screen/overlay.
 *
 * Pattern (same as #9 `/?q=`): `validateSearch` omits defaults (does not pollute the
 * URL when empty) and hosts reflect URL→signals + navigate with
 * `{ replace: true }` when opening/closing (idempotent, survives back/forward and
 * a pasted URL).
 */

export interface AppLayoutSearch {
  // ── Account change (multi-account #18) ─────────────────────────────────────
  /** Account switcher open (`?account=switch`).*/
  account?: "switch";
}

/**
 * Validates + normalizes the layout search. Omits defaults to keep the URL
 * clean. Tolerant: unknown values are discarded (does not break rendering).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};

  // ── Account switcher (multi-account) ──
  if (search.account === "switch") {
    out.account = "switch";
  }

  return out;
}
